import React from 'react'
import { CallToAction } from 'components/CallToAction'
import { SignupCTA } from 'components/SignupCTA'

export function ArrayCTA({ title, subtitle, ctas, allArrayCTA }) {
    const titleInput = title || allArrayCTA?.title || 'Ready to find out more?'
    const subtitleInput = subtitle || allArrayCTA?.subtitle
    const defailtCTAs = [
        {
            href: 'https://app.icloud-ready.com/register',
            text: 'Try iCloudReady - free',
            type: 'primary',
            width: '56',
        },
        {
            href: '/book-a-meeting',
            text: 'Schedule a demo',
            type: 'outline',
            width: '56',
        },
    ]
    const ctasInput = ctas || allArrayCTA
    return (
        <>
            <br />
            <p className="relative z-10 mb-0 px-4 text-center text-sm font-bold md:text-lg">{titleInput}</p>
            <div className="flex flex-col items-center justify-center gap-2 md:flex-row xl:gap-4">
                {ctasInput && ctasInput.length > 0 ? (
                    <div className="flex flex-col items-center space-y-3">
                        {ctasInput.map(({ text, href, width, type }, index) => (
                            <CallToAction key={index} href={href} width={width} type={type}>
                                {text}
                            </CallToAction>
                        ))}
                    </div>
                ) : (
                    <>
                        <SignupCTA width="56" text="Try iCloudReady - free" />
                        <CallToAction type="outline" width="56" to="">
                            Schedule a demo
                        </CallToAction>
                    </>
                )}
            </div>
            <br />
        </>
    )
}
export default ArrayCTA
